import { gql } from '@apollo/client';

export const UPDATE_ARBEITSBEREICH_STATION = gql(`
  mutation rotationsplan_updateArbeitsbereichStation($input: mitarbeiter_updateArbeitsbereichStationInput!) {
   mitarbeiter_updateArbeitsbereichStation(input: $input){
    error {
      message
    }
    success {
      station {
        ... on mitarbeiter_rotationsplanArbeitsbereichStation {
          von
          bis
          id
          lernziele
          abteilungsleiter {
            id
            nachname
            vorname
          }
          arbeitsbereich {
            id
            name
            markierung
          }
        }
      }
      fristResult {
        ... on mitarbeiter_CreateOrUpdateArbeitsbereichStationFristResponse {
          error {
            message
          }
          success {
            id
          }
        }
        ... on mitarbeiter_DeleteArbeitsbereichStationFristResponse {
          error {
            message
          }
          fristId: success
        }
      }
    }
  }
}
`);
